/* tslint:disable */
/* eslint-disable */
/**
 * Business Orchestration layer (BOL) Notifications API
 * Business Orchestration layer (BOL) Notifications API.  This API is used to manage subscriptions and consumers for BOL notifications. 
 *
 * The version of the OpenAPI document: 7.2.1-develop.2
 * Contact: benoit.tiers@logist-x.eu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionQuotasConsumers
 */
export interface SubscriptionQuotasConsumers {
    /**
     * Maximum number of consumers for this subscription.
     * @type {number}
     * @memberof SubscriptionQuotasConsumers
     */
    maxCount?: number;
}

/**
 * Check if a given object implements the SubscriptionQuotasConsumers interface.
 */
export function instanceOfSubscriptionQuotasConsumers(value: object): value is SubscriptionQuotasConsumers {
    return true;
}

export function SubscriptionQuotasConsumersFromJSON(json: any): SubscriptionQuotasConsumers {
    return SubscriptionQuotasConsumersFromJSONTyped(json, false);
}

export function SubscriptionQuotasConsumersFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionQuotasConsumers {
    if (json == null) {
        return json;
    }
    return {
        
        'maxCount': json['maxCount'] == null ? undefined : json['maxCount'],
    };
}

export function SubscriptionQuotasConsumersToJSON(json: any): SubscriptionQuotasConsumers {
    return SubscriptionQuotasConsumersToJSONTyped(json, false);
}

export function SubscriptionQuotasConsumersToJSONTyped(value?: SubscriptionQuotasConsumers | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'maxCount': value['maxCount'],
    };
}

